import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper, Checkbox,
  Avatar,
  CircularProgress,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Menu,
  Grid,
  ListItemIcon,
  ListItemText, DialogActions, DialogContent, DialogTitle, Dialog
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { GlobalStyles } from "@mui/system";
import { useFormik } from "formik";
import { IconButton } from "@mui/material";
import * as XLSX from "xlsx";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useAuth } from "../../../AuthProvider";

import ExcelJS from "exceljs";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import PresentToAllIcon from "@mui/icons-material/PresentToAll";
import SimCardDownloadIcon from "@mui/icons-material/SimCardDownload";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import FilePresentIcon from "@mui/icons-material/FilePresent";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const today = new Date();
today.setDate(today.getDate() - 1);
const yesterday = today.toISOString().split("T")[0];

const baseUrl = process.env.REACT_APP_API_BASE_URL;
const StudentAttendance = () => {
  const navigate = useNavigate();
  const { oId, board, pId, userId, role } = useAuth();
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [originalData, setOriginalData] = useState([]); // Original API data

  const [loading, setLoading] = useState(true);


  const [sscClassOptions, setSscClassOptions] = useState([]);
  const [sscSectionOptions, setSscSectionOptions] = useState([]);
  const [sscSelectedClass, setSscSelectedClass] = useState("");
  const [sscSelectedSection, setSscSelectedSection] = useState("");

  // INTERMEDIATE states
  const [interSectionOptions, setInterSectionOptions] = useState([]);
  const [interSelectedClass, setInterSelectedClass] = useState("Inter-1st-Year");
  const [interSelectedSection, setInterSelectedSection] = useState("");
  const [courseOptions, setCourseOptions] = useState([]);
  const [selectedCourseType, setSelectedCourseType] = useState("");

  const [sscClassSectionMap, setSscClassSectionMap] = useState({});


  // Initialize with today's date (YYYY-MM-DD)
  const today = new Date().toISOString().split("T")[0];
  const [selectedDate, setSelectedDate] = useState(today);

  // const [selectedStudents, setSelectedStudents] = useState([]);
  // const [selectAll, setSelectAll] = useState(false);
  // --- State ---
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [selectAll, setSelectAll] = useState(true); // ✅ default: all selected



  const [dateRange, setDateRange] = useState("today");
  const [singleDate, setSingleDate] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [submitting, setSubmitting] = useState(false);


  const [exportAnchorEl, setExportAnchorEl] = useState(null);
  const isExportMenuOpen = Boolean(exportAnchorEl);

  const handleExportClick = (event) => {
    setExportAnchorEl(event.currentTarget);
  };

  const handleExportClose = () => {
    setExportAnchorEl(null);
  };
  const handleClose = () => {
    setExportAnchorEl(null);
  };


  const [exportFilter, setExportFilter] = useState("All");

  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState("");

  const UserId = selectedUsers;
  console.log("Selected User:", UserId);



  const fetchUsers = async () => {
    try {
      const response = await fetch(`${baseUrl}/api/principal/getAllUserIdsAndNames/ADMISSION_FEE/${oId}/${pId}`);
      if (!response.ok) {
        throw new Error('Failed to fetch users');
      }
      const data = await response.json();
      setUsers(data);
      if (data.length > 0) {
        setSelectedUsers(data[0].userId); // ✅ Set first record's userId as default
      }
    } catch (error) {
      console.error('Error fetching users:', error);
    }
  };
  useEffect(() => {

    fetchUsers();

  }, []); // ✅ Only runs on mount

  // -------------------------------------------
  //           For SSC functions
  // -------------------------------------------

  // ---- Fetch Class + Sections for SSC (School) ----
  const fetchClassRegistrationData = async () => {
    try {
      const response = await fetch(`${baseUrl}/api/dynamic-classReg/class-registrations/${oId}/${pId}`);
      const data = await response.json();

      if (response.ok && Array.isArray(data)) {
        const classSectionMap = {};

        data.forEach(item => {
          const className = item.classRegistration;
          const sectionList = item.sections.split(",").map(s => s.trim());

          if (!classSectionMap[className]) {
            classSectionMap[className] = new Set();
          }

          sectionList.forEach(section => classSectionMap[className].add(section));
        });

        const classes = Object.keys(classSectionMap);
        setSscClassOptions(classes); // Populate class dropdown
        setSscClassSectionMap(classSectionMap); // Save mapping

        // ✅ Set default class and sections (first record)
        const defaultClass = classes[0];
        const defaultSections = Array.from(classSectionMap[defaultClass]);
        const defaultSection = defaultSections.includes("Section-A")
          ? "Section-A"
          : defaultSections[0] || "";

        setSscSelectedClass(defaultClass);
        setSscSectionOptions(defaultSections);
        setSscSelectedSection(defaultSection);
      }
    } catch (error) {
      console.error("Error fetching SSC data:", error);
    }
  };

  useEffect(() => {
    fetchClassRegistrationData();
  }, [oId, pId]);



  // ---- Fetch Table Data for SSC ----
  const fetchClassSectionTableData = async () => {
    if (!UserId || !sscSelectedClass || !sscSelectedSection) {
      setFilteredData([]);
      setOriginalData([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    try {
      let response;

      if (dateRange === "today") {
        response = await fetch(
          `${baseUrl}/api/admission/adm/getAllFilterWithClassesAndSectionStudentAttendance/${oId}/${UserId}?romanNumberClass=${sscSelectedClass}&sections=${sscSelectedSection}&customDate=${today}`
        );
      } else if (dateRange === "customDate" && singleDate) {
        response = await fetch(
          `${baseUrl}/api/admission/adm/getAllFilterWithClassesAndSectionStudentAttendance/${oId}/${UserId}?romanNumberClass=${sscSelectedClass}&sections=${sscSelectedSection}&customDate=${singleDate}`
        );
      } else {
        setLoading(false);
        return;
      }

      if (!response.ok) {
        throw new Error(`HTTP Error: ${response.status}`);
      }

      const data = await response.json();

      if (Array.isArray(data)) {

        // ✅ Sort by Roll No Ascending (1,2,3,4...)
      const sortedData = data.sort(
        (a, b) => Number(a.studentRollNumber) - Number(b.studentRollNumber)
      );

        setOriginalData(sortedData);
        setFilteredData(sortedData);
        // Example: setUniqueCourseType([...new Set(data.map(item => item.course))]);
      } else {
        setOriginalData([]);
        setFilteredData([]);
      }
    } catch (error) {
      console.error("Error fetching SSC table data:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchClassSectionTableData();
  }, [UserId, sscSelectedClass, sscSelectedSection, dateRange, singleDate, today]);








  useEffect(() => {
    if (!searchQuery) {
      setFilteredData(originalData); // Reset to original data if search query is empty
      return;
    }

    const result = originalData.filter((student) => {
      const searchTerm = searchQuery.toLowerCase();
      return (
        String(student.customAdmissionNumber).toLowerCase().includes(searchTerm) || // Add search by admission number
        String(student.surName).toLowerCase().includes(searchTerm) ||
        String(student.firstName).toLowerCase().includes(searchTerm) ||
        String(student.lastName).toLowerCase().includes(searchTerm) ||
        String(student.primaryContact).includes(searchTerm)
      );
    });

    setFilteredData(result);
  }, [searchQuery, originalData]);



  // --- Effect to select all by default only once when data is fetched ---
  useEffect(() => {
    if (filteredData.length > 0 && selectedStudents.length === 0) {
      setSelectedStudents(filteredData.map((row) => row.studentId));
      setSelectAll(true);
    }
  }, [filteredData]); // ✅ depends on originalData only

  // 🟢 Default select all when new data is loaded
  useEffect(() => {
    if (originalData.length > 0) {
      // Select all students whenever new class/section data is fetched
      setSelectedStudents(originalData.map((row) => row.studentId));
      setSelectAll(true);
    } else {
      // Reset if no records found
      setSelectedStudents([]);
      setSelectAll(false);
    }
  }, [originalData]);



  // --- Handle Select All ---
  const handleSelectAll = (event) => {
    const checked = event.target.checked;
    setSelectAll(checked);
    if (checked) {
      setSelectedStudents(filteredData.map((row) => row.studentId));
    } else {
      setSelectedStudents([]);
    }
  };

  // --- Handle Single Student Toggle ---
  const handleSelectStudent = (studentId) => {
    setSelectedStudents((prev) => {
      const newSelection = prev.includes(studentId)
        ? prev.filter((id) => id !== studentId)
        : [...prev, studentId];

      // Auto-update selectAll checkbox based on selection
      setSelectAll(newSelection.length === filteredData.length);
      return newSelection;
    });
  };



  // Handle date range selection
  const handleDateRangeChange = (e) => {
    const selectedValue = e.target.value;
    setDateRange(selectedValue);

    // Reset date fields when switching options
    setSingleDate("");
    setStartDate("");
    setEndDate("");
  };

  const handleAttendanceSubmit = async () => {
      if (submitting) return; 

    if (!selectedStudents || selectedStudents.length === 0) {
      toast.warn("Please select at least one student.", { autoClose: 2000 });
      return;
    }

    setSubmitting(true);
    try {
      // Convert selected student IDs to comma-separated format
      const studentIds = selectedStudents.join(",");

      let apiUrl = "";

      if (dateRange === "today") {
        // 🟢 TODAY API
        apiUrl = `${baseUrl}/api/attendance/customDate/checkin/all/${oId}/${pId}/${today}?romanNumberClass=${sscSelectedClass}&sections=${sscSelectedSection}&employeeIds=${studentIds}`;
      }
      else if (dateRange === "customDate" && singleDate) {
        // 🟡 CUSTOM DATE API (uses singleDate as both startDate and endDate)
        apiUrl = `${baseUrl}/api/attendance/customDate/checkin/all/${oId}/${pId}/${singleDate}?romanNumberClass=${sscSelectedClass}&sections=${sscSelectedSection}&employeeIds=${studentIds}`;
      }
      else if (dateRange === "customDateRange" && startDate && endDate) {
        // 🔵 CUSTOM DATE RANGE API
        apiUrl = `${baseUrl}/api/attendance/bulkStudents/checkin/all/${oId}/${pId}?romanNumberClass=${sscSelectedClass}&sections=${sscSelectedSection}&startDate=${startDate}&endDate=${endDate}&employeeIds=${studentIds}`;
      }
      else {
        toast.warn("Please select valid date(s) before submitting.", { autoClose: 2000 });
        setSubmitting(false);
        return;
      }

      // 🔻 Make POST request
      const response = await fetch(apiUrl, { method: "POST" });
      if (!response.ok) throw new Error(`HTTP Error: ${response.status}`);

      const data = await response.json();
      console.log("Response:", data);
      fetchClassSectionTableData();
      toast.success("Attendance submitted successfully!", { autoClose: 1000 });
    } catch (error) {
      console.error("Error submitting attendance:", error);
      toast.error("Attendance already exists.", { autoClose: 2000 });
    } finally {
      setSubmitting(false);
    }
  };







  // ✅ Export to Excel
  const exportToExcel = () => {

    const filteredForExport =
      exportFilter === "All"
        ? filteredData
        : filteredData.filter(
          (row) => row.studentTodayAttendanceStatus === exportFilter
        );

    if (filteredForExport.length === 0) {
      toast.warn(`No ${exportFilter.toLowerCase()} students to export`);
      handleExportClose();
      return;
    }

    const processedData = filteredForExport.map(
      ({
        studentRollNumber,
        romanNumberClass,
        sections,
        firstName,
        lastName,
        gender,
        fathersFirstName,
        fathersLastName,
        primaryContact,
        studentTodayAttendanceStatus,
      }) => ({
        RollNo: studentRollNumber,
        Class: romanNumberClass,
        Section: sections,
        StudentName: `${firstName} ${lastName}`,
        Gender: gender,
        FatherName: `${fathersFirstName} ${fathersLastName}`,
        Phone: primaryContact,
        Attendance: studentTodayAttendanceStatus || "No Data",
      })
    );

    // 🟩 Dynamically set worksheet & filename
    const fileName =
      dateRange === "today"
        ? `${sscSelectedClass}-${sscSelectedSection}_${exportFilter}_Today_Attendance`
        : `${sscSelectedClass}-${sscSelectedSection}_${exportFilter}_${singleDate}_Attendance`;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(fileName);

    // Define headers
    worksheet.columns = [
      { header: "Roll No", key: "RollNo", width: 10 },
      { header: "Class", key: "Class", width: 10 },
      { header: "Section", key: "Section", width: 10 },
      { header: "Student Name", key: "StudentName", width: 25 },
      { header: "Gender", key: "Gender", width: 10 },
      { header: "Father Name", key: "FatherName", width: 20 },
      { header: "Phone", key: "Phone", width: 15 },
      { header: "Attendance", key: "Attendance", width: 15 },
    ];

    // Add data rows + attendance coloring
    processedData.forEach((data) => {
      const row = worksheet.addRow(data);
      const attendanceCell = row.getCell("Attendance");

      if (data.Attendance === "Present") {
        attendanceCell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "C6EFCE" },
        };
        attendanceCell.font = { color: { argb: "006100" }, bold: true };
      } else if (data.Attendance === "Absent") {
        attendanceCell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFC7CE" },
        };
        attendanceCell.font = { color: { argb: "9C0006" }, bold: true };
      }
    });

    // Header styling
    worksheet.getRow(1).eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: "center" };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "ADD8E6" },
      };
    });

    // Save file
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `${fileName}.xlsx`;
      link.click();
    });

    handleExportClose();
  };

  // ✅ Export to PDF
  const exportToPDF = () => {

    const filteredForExport =
      exportFilter === "All"
        ? filteredData
        : filteredData.filter(
          (row) => row.studentTodayAttendanceStatus === exportFilter
        );

    if (filteredForExport.length === 0) {
      toast.warn(`No ${exportFilter.toLowerCase()} students to export`);
      handleExportClose();
      return;
    }


    const doc = new jsPDF();

    // 🟦 Dynamic file name & title
    const fileName =
      dateRange === "today"
        ? `${sscSelectedClass}-${sscSelectedSection}_${exportFilter}_Today_Attendance`
        : `${sscSelectedClass}-${sscSelectedSection}_${exportFilter}_${singleDate}_Attendance`;

    // 🏷️ Title
    doc.setFontSize(16);
    doc.setFont("helvetica", "bold");
    doc.text(`${sscSelectedClass}-${sscSelectedSection} Attendance Report`, 10, 10);

    // 🕒 Generated Date
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.text(`Generated On: ${new Date().toLocaleDateString()}`, 10, 16);

    // 🧾 Table headers
    const headers = [
      "Roll No",
      "Class",
      "Section",
      "Student Name",
      "Gender",
      "Father Name",
      "Phone",
      "Attendance",
    ];

    // 🧩 Table body
    const bodyData = filteredForExport.map((row) => [
      row.studentRollNumber,
      row.romanNumberClass,
      row.sections,
      `${row.firstName} ${row.lastName}`,
      row.gender,
      `${row.fathersFirstName} ${row.fathersLastName}`,
      row.primaryContact,
      row.studentTodayAttendanceStatus || "No Data",
    ]);

    // 📋 AutoTable with attendance coloring
    doc.autoTable({
      startY: 22,
      head: [headers],
      body: bodyData,
      theme: "grid",
      styles: {
        halign: "center",
        fontSize: 9,
      },
      headStyles: {
        fillColor: [63, 81, 181],
        textColor: 255,
      },
      didParseCell: (data) => {
        if (data.section === "body" && data.column.index === 7) {
          const status = data.cell.raw;
          if (status === "Present") {
            data.cell.styles.fillColor = [198, 239, 206];
            data.cell.styles.textColor = [0, 97, 0];
            data.cell.styles.fontStyle = "bold";
          } else if (status === "Absent") {
            data.cell.styles.fillColor = [255, 199, 206];
            data.cell.styles.textColor = [156, 0, 6];
            data.cell.styles.fontStyle = "bold";
          }
        }
      },
    });

    // 💾 Save file with correct name
    doc.save(`${fileName}.pdf`);
    handleExportClose();
  };


  return (
    <Box sx={{ mt: "5%", mr: "1%", ml: "1%" }}>
      <Card
        sx={{
          marginTop: "60px",
          width: "100%",
          borderRadius: 3,
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        }}
      >
        <CardContent>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={{ marginBottom: 2 }}
          >
            {/* 🔹 Left Section: Page Title */}
            <Box display="flex" alignItems="center">
              <Typography variant="h4" component="h3" sx={{ fontWeight: "bold" }}>
                Student Attendance
              </Typography>
            </Box>

            {/* 🔹 Right Section: Filter + Export */}
            <Box display="flex" alignItems="center" gap={2}>
              {/* 🟣 Dropdown Filter */}
              <FormControl size="small" sx={{ minWidth: 150 }}>
                <InputLabel>Export</InputLabel>
                <Select
                  value={exportFilter}
                  label="Export"
                  onChange={(e) => setExportFilter(e.target.value)}
                >
                  <MenuItem value="All">All</MenuItem>
                  <MenuItem value="Present">Present</MenuItem>
                  <MenuItem value="Absent">Absent</MenuItem>
                </Select>
              </FormControl>

              {/* 🟢 Export Button */}
              <Button
                variant="contained"
                onClick={handleExportClick}
                sx={{
                  backgroundColor: "#3C3972",
                  fontWeight: "bold",
                  "&:hover": { backgroundColor: "#2e2a54" },
                }}
                startIcon={<PresentToAllIcon />}
              >
                Export
              </Button>

              <Menu
                anchorEl={exportAnchorEl}
                open={isExportMenuOpen}
                onClose={handleExportClose}
                sx={{
                  "& .MuiPaper-root": {
                    backgroundColor: "#f5f5f5",
                    borderRadius: "8px",
                  },
                }}
              >
                <MenuItem
                  onClick={exportToExcel}
                  sx={{
                    color: "#00796b",
                    fontWeight: "bold",
                    "&:hover": { backgroundColor: "#e8f0fe" },
                  }}
                >
                  <ListItemIcon sx={{ color: "#00796b" }}>
                    <SimCardDownloadIcon />
                  </ListItemIcon>
                  <ListItemText primary="Excel" />
                </MenuItem>

                <MenuItem
                  onClick={exportToPDF}
                  sx={{
                    color: "#d32f2f",
                    fontWeight: "bold",
                    "&:hover": { backgroundColor: "#fdecea" },
                  }}
                >
                  <ListItemIcon sx={{ color: "#d32f2f" }}>
                    <PictureAsPdfIcon />
                  </ListItemIcon>
                  <ListItemText primary="PDF" />
                </MenuItem>
              </Menu>
            </Box>
          </Box>



          <Box display="flex" mb={3} flexWrap="wrap">
            <TextField
              label="Search by Name"
              variant="outlined"
              size="small"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              sx={{ marginRight: 2 }}
            />


            {board === "SSC" && (
              <>
                <FormControl size="small" sx={{ minWidth: 120, marginRight: 2 }}>
                  <InputLabel id="class-select-label">Select Class</InputLabel>
                  <Select
                    labelId="class-select-label"
                    value={sscSelectedClass}
                    // onChange={(e) => setSscSelectedClass(e.target.value)}
                    onChange={(e) => {
                      const selected = e.target.value;
                      setSscSelectedClass(selected);

                      const sections = sscClassSectionMap[selected] ? Array.from(sscClassSectionMap[selected]) : [];
                      setSscSectionOptions(sections);
                      setSscSelectedSection(sections.includes("Section-A") ? "Section-A" : sections[0] || "");
                    }}
                    label="Select Class"
                    sx={{ height: 35 }}
                  >
                    {sscClassOptions.map((cls) => (
                      <MenuItem key={cls} value={cls}>{cls}</MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <FormControl size="small" sx={{ minWidth: 120, marginRight: 2 }}>
                  <InputLabel id="section-select-label">Select Section</InputLabel>
                  <Select
                    labelId="section-select-label"
                    value={sscSelectedSection}
                    onChange={(e) => setSscSelectedSection(e.target.value)}
                    label="Select Section"
                    sx={{ height: 35 }}
                    disabled={sscSectionOptions.length === 0}
                  >
                    {sscSectionOptions.map((section) => (
                      <MenuItem key={section} value={section}>{section}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </>
            )}


            {board === "INTERMEDIATE" && (
              <>
                <FormControl size="small" sx={{ minWidth: 120, marginRight: 2 }}>
                  <InputLabel id="intermediate-class-select-label">Select Year</InputLabel>
                  <Select
                    labelId="intermediate-class-select-label"
                    value={interSelectedClass}
                    onChange={(e) => setInterSelectedClass(e.target.value)}
                    label="Select Year"
                    sx={{ height: 35 }}
                  >
                    <MenuItem value="Inter-1st-Year">Inter-1st-Year</MenuItem>
                    <MenuItem value="Inter-2nd-Year">Inter-2nd-Year</MenuItem>
                  </Select>
                </FormControl>

                <FormControl size="small" sx={{ minWidth: 120, marginRight: 2 }}>
                  <InputLabel id="course-type-label">Select Course</InputLabel>
                  <Select
                    labelId="course-type-label"
                    value={selectedCourseType}
                    onChange={(e) => setSelectedCourseType(e.target.value)}
                    label="Select Course"
                    sx={{ height: 35 }}
                  >
                    {courseOptions.map((course, index) => (
                      <MenuItem key={index} value={course}>{course}</MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <FormControl size="small" sx={{ minWidth: 120, marginRight: 2 }}>
                  <InputLabel id="intermediate-section-select-label">Select Section</InputLabel>
                  <Select
                    labelId="intermediate-section-select-label"
                    value={interSelectedSection}
                    onChange={(e) => setInterSelectedSection(e.target.value)}
                    label="Select Section"
                    sx={{ height: 35 }}
                  >
                    {interSectionOptions.map((section, index) => (
                      <MenuItem key={index} value={section}>{section}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </>
            )}


            {/* Date Range Dropdown */}
            <FormControl size="small" style={{ width: "140px", marginRight: '10px' }}>
              <InputLabel>Select DateRange</InputLabel>
              <Select
                value={dateRange}
                // onChange={(e) => setDateRange(e.target.value)}
                onChange={handleDateRangeChange}
                label="Select DateRange"
                style={{ height: "35px", fontSize: "12px" }}
              >
                <MenuItem value="today">Today</MenuItem>
                <MenuItem value="customDate">Custom Date</MenuItem>
                {/* <MenuItem value="customDateRange">Custom Date Range</MenuItem> */}
              </Select>
            </FormControl>

            {/* --- Conditionally Render Date Fields --- */}
            {dateRange === "customDate" && (
              // <TextField
              //   type="date"
              //   size="small"
              //   value={singleDate}
              //   onChange={(e) => setSingleDate(e.target.value)}
              //   sx={{ width: "160px", marginRight: '10px' }}
              //   inputProps={{
              //     max: new Date().toISOString().split("T")[0], // 👈 disables future dates
              //   }}
              // />

              <TextField
                type="date"
                size="small"
                value={singleDate}
                onChange={(e) => setSingleDate(e.target.value)}
                sx={{ width: "160px", marginRight: '10px' }}
                inputProps={{
                  max: yesterday,   // 👈 today disabled
                }}
              />

            )}

            {dateRange === "customDateRange" && (
              <>
                <TextField
                  type="date"
                  size="small"
                  label="Start Date"
                  InputLabelProps={{ shrink: true }}
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  sx={{ width: "160px", marginRight: '10px' }}
                  inputProps={{
                    max: yesterday,  // 👈 today disabled
                  }}
                />
                <TextField
                  type="date"
                  size="small"
                  label="End Date"
                  InputLabelProps={{ shrink: true }}
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  sx={{ width: "160px", marginRight: '10px' }}
                  inputProps={{
                    max: yesterday,  // 👈 today disabled
                  }}
                />
              </>
            )}

            <Button
              variant="contained"
              color="success"
              onClick={handleAttendanceSubmit}
              disabled={submitting}
              sx={{
                // height: "40px",
                fontWeight: "bold",
                px: 3,
              }}
            >
              {submitting ? "Submitting..." : "Mark Attendance"}
            </Button>

            {/* <FormControl fullWidth style={{ width: "150px" ,marginLeft:'5px'}} size="small">
            <InputLabel>Select Admission Admin</InputLabel>
            <Select
              value={selectedUsers}
              onChange={(e) => setSelectedUsers(e.target.value)}
              label="Select Admission Admin"
            >
              {users.map((user) => (
                <MenuItem key={user.userId} value={user.userId}>
                  {user.userId}-{user.firstName} {user.lastName}
                </MenuItem>
              ))}
            </Select>
          </FormControl> */}



            <Box sx={{ flexGrow: 1 }} />


          </Box>

          <GlobalStyles
            styles={{
              ".custom-sidebar-scrollbar": {
                scrollbarWidth: "thin", // For Firefox
                scrollbarColor: "grey #e0e0e0",
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar": {
                width: "6px", // For WebKit-based browsers
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar-track": {
                background: "#f1f1f1", // Track color
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb": {
                backgroundColor: "grey", // Thumb color
                borderRadius: "10px",
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover": {
                backgroundColor: "#555",
              },
            }}
          />

          <TableContainer
            component={Paper}
            sx={{
              borderRadius: 2,
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              maxHeight: "800px",
              overflow: "auto",
            }}
            className="custom-sidebar-scrollbar"
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  {/* Select All Checkbox */}
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      backgroundColor: "#fff9c4",
                      textAlign: "center",
                      fontWeight: "bold",
                      padding: "4px",
                    }}
                  >
                    <Checkbox
                      checked={selectAll}
                      onChange={handleSelectAll}
                      size="small"
                      sx={{
                        color: "black", // unchecked color
                        "&.Mui-checked": {
                          color: "green", // ✅ selected color
                        },
                      }}
                    />
                  </TableCell>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      textAlign: "center",
                      backgroundColor: "#fff9c4",
                      fontWeight: "Bold",
                    }}
                  >
                    Roll No
                  </TableCell>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      backgroundColor: "#fff9c4",
                      textAlign: "center",
                      fontWeight: "Bold",
                    }}
                  >
                    Class
                  </TableCell>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      backgroundColor: "#fff9c4",
                      textAlign: "center",
                      fontWeight: "Bold",
                    }}
                  >
                    Section
                  </TableCell>


                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      textAlign: "center",
                      whiteSpace: "nowrap",
                      backgroundColor: "#fff9c4",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      fontWeight: "Bold",
                    }}
                  >
                    Name
                  </TableCell>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      textAlign: "center",
                      whiteSpace: "nowrap",
                      backgroundColor: "#fff9c4",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      fontWeight: "Bold",
                    }}
                  >
                    Status
                  </TableCell>

                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      textAlign: "center",
                      backgroundColor: "#fff9c4",
                      fontWeight: "Bold",
                    }}
                  >
                    View Attendance
                  </TableCell>
                  {/* <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      backgroundColor: "#fff9c4",
                      textAlign: "center",
                      fontWeight: "Bold",
                    }}
                  >
                    Gender
                  </TableCell> */}



                  {/* <TableCell
                    sx={{
                      padding: "4px",
                      backgroundColor: "#fff9c4",
                      textAlign: "center",
                      fontWeight: "Bold",
                    }}
                  >
                    Action
                  </TableCell> */}
                </TableRow>
              </TableHead>
              {loading ? (
                <TableBody>
                  <TableRow>
                    <TableCell
                      colSpan={11}
                      style={{ textAlign: "center", padding: "20px" }}
                    >
                      <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                      >
                        <CircularProgress />
                        <Typography variant="body2" sx={{ mt: 1 }}>
                          Loading Data...
                        </Typography>
                      </Box>
                    </TableCell>
                  </TableRow>

                </TableBody>
              ) : filteredData.length === 0 ? (
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={13} sx={{ textAlign: "center" }}>
                      No data found
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : (
                <TableBody>
                  {filteredData.map((row, index) => (
                    <TableRow
                      key={row.admissionNumber}
                      style={{
                        backgroundColor: "white",
                        transition: "background-color 0.3s",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = "#f5f5f5"; // Hover color
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = "white"; // Default color
                      }}
                    >

                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                        }}>
                        <Checkbox
                          checked={selectedStudents.includes(row.studentId)}
                          disabled={row.studentTodayAttendanceStatus === "Present"} // 🚫 Disable only Present
                          onChange={() => handleSelectStudent(row.studentId)}
                          size="small"
                          //                    sx={{
                          //   color: "black", // unchecked color
                          //   "&.Mui-checked": {
                          //     color: {row.studentTodayAttendanceStatus === "Present" : "gray" ? "green"} // ✅ selected color
                          //   },
                          // }}

                          sx={{
                            color:
                              row.studentTodayAttendanceStatus === "Present"
                                ? "gray" // 🟢 Gray when Present (disabled)
                                : "green", // ✅ Green when Absent or Empty
                            "&.Mui-checked": {
                              color:
                                row.studentTodayAttendanceStatus === "Present"
                                  ? "gray"
                                  : "green",
                            },
                          }}
                        />
                      </TableCell>





                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                        }}
                      >
                        {row.studentRollNumber}
                      </TableCell>


                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "3px",
                          textAlign: "center",
                        }}
                      >
                        {row.romanNumberClass}
                      </TableCell>
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                        }}
                      >
                        {row.sections}
                      </TableCell>

                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                        }}
                      >{`${row.firstName} ${row.lastName}`}</TableCell>
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "2px",
                          textAlign: "center",
                          maxWidth: "80px",
                          minWidth: "80px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <Box
                          sx={{
                            display: "inline-block",
                            padding: "6px 12px",
                            borderRadius: "20px",
                            fontWeight: "bold",
                            color: "#fff",
                            background:
                              row.studentTodayAttendanceStatus === "Present"
                                ? "linear-gradient(45deg, #66bb6a, #43a047)" // ✅ Green for Present
                                : row.studentTodayAttendanceStatus === "Absent"
                                  ? "linear-gradient(45deg, #e57373, #e53935)" // ❌ Red for Absent
                                  : "linear-gradient(45deg, #9e9e9e, #757575)", // ⚪ Gray for No Data / Others
                            textAlign: "center",
                            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                            minWidth: "70px",
                            transition: "all 0.3s ease-in-out",
                            "&:hover": {
                              transform: "translateY(-3px)",
                              boxShadow: "0px 8px 15px rgba(0, 0, 0, 0.3)",
                            },
                          }}
                        >
                          {row.studentTodayAttendanceStatus || "No Data"}
                        </Box>
                      </TableCell>

                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                          cursor: 'pointer',
                        }}
                        onClick={() => {
                          // ✅ Store details in sessionStorage
                          sessionStorage.setItem("selectedStudentName", `${row.firstName} ${row.lastName}`);

                          // ✅ Navigate
                          navigate(`/StudentAttendanceCalendar/${row.studentId}/${row.romanNumberClass}`);
                        }}
                      >
                        <Box
                          component="span"
                          sx={{
                            fontSize: "24px",
                            display: "inline-block",
                            transition: "transform 0.2s, color 0.2s",
                            "&:hover": {
                              color: "#1976d2",
                              transform: "scale(1.2)",
                            },
                          }}
                        >
                          🗓️
                        </Box>
                      </TableCell>



                      {/* <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          textAlign: "center",
                        }}
                      >
                        <Button
                          type="button"
                        //   onClick={() => {
                        //       // Store student data in sessionStorage
                        //       sessionStorage.setItem("studentName", JSON.stringify(row));

                        //       // Navigate to the desired route
                        //       navigate(`/AllStockItemsListForStudents/${row.studentId}`);
                        //     }}

                          sx={{
                            backgroundColor: "#1976d2",
                            color: "white",
                            fontSize: "0.6rem", // Reduces the font size
                            // padding: "5px 10px",  // Reduces the padding
                            height: "25px", // Reduces the height
                            "&:hover": {
                              backgroundColor: "#1565c0",
                            },
                          }}
                        >
                          Attendance
                        </Button>
                      </TableCell> */}
                    </TableRow>
                  ))}
                </TableBody>
              )}
            </Table>



          </TableContainer>
          {/* Attendance All Students Button */}
          <Box
            display="flex"
            alignItems="center"
            justifyContent="flex-start"
            gap={2}
            mt={2}
            flexWrap="wrap"
          >

            {/* Attendance Button */}
            {/* <Button
        variant="contained"
        color="success"
        onClick={handleAttendanceSubmit}
        disabled={submitting}
        sx={{
          height: "40px",
          fontWeight: "bold",
          px: 3,
        }}
      >
        {submitting ? "Submitting..." : "Mark Attendance"}
      </Button> */}
          </Box>

          <ToastContainer position="top-right" autoClose={1000} /> {/* Default 1s close */}
        </CardContent>


      </Card>
    </Box>
  );
};

export default StudentAttendance;